import { render } from "./TextMessageWithTooltip.vue?vue&type=template&id=01cba784&scoped=true"
import script from "./TextMessageWithTooltip.vue?vue&type=script&lang=js"
export * from "./TextMessageWithTooltip.vue?vue&type=script&lang=js"

import "./TextMessageWithTooltip.vue?vue&type=style&index=0&id=01cba784&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01cba784"]])

export default __exports__